export default "assets/download-outline-e42107eb.svg";